import { AsEnactedTabModel } from "./../../models/tabs/as-enacted";
import { StatuteOutlineView } from "./../statute-outline";
import { backboneViewProperties } from "./../../../decorators/backbone-properties";
import { AppSettings } from "./../../../app-settings";
import {FulltextTabView} from "./fulltext-tab";

const dom = {
    STATUTE_OUTLINE_BUTTON: ".btn-statute-outline",
};

export class AsEnactedView extends FulltextTabView {

    public model: AsEnactedTabModel;
    private statuteOutlineRegion: Marionette.Region;
    private statuteOutlineView: StatuteOutlineView;

    public onShow() {
        super.onShow();
    }

    public regions(): any {
        const regions: any = {
            statuteOutlineRegion: ".statute-outline-region",
        };
        return regions;
    }

    // The pdf reader needs to refresh the access token so that it can get the pdf in the link
    protected loadDocumentPdf(pdfLink: string): Promise<any> {
        return new Promise(() => {
            let protocolAddition = "";

            if (AppSettings.DocumentApiUrlPrefix.substr(0, 2) !== "//") {
                protocolAddition = window.location.protocol + "//" + window.location.hostname + "/";
            }

            let pdfUrl = `${protocolAddition}${AppSettings.DocumentApiUrlPrefix}judgmentpdf?docKey=${this.model.Data.Id}&pdfLink=${pdfLink}`;
            pdfUrl = encodeURIComponent(pdfUrl);
            const readerUrl = `assets/pdf-reader/web/viewer.html?file=${pdfUrl}&v=${AppSettings.AppVersion}`;
            const existing = this.$(".full-text-pdf iframe").attr("src");
            if (existing !== readerUrl) {
                const frame = $(`<iframe src='${readerUrl}' class='pdf-frame' frameborder="0"></iframe>`);
                this.$(".full-text-pdf").empty().append(frame);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/as-enacted.ts